export default __webpack_public_path__ + "static/B0192-f048648eb9b63c41dae985bf5fdd279b.png";